import React, { useEffect, useState } from 'react';
import { Form, Table } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { api, endpoints } from '../../api';
import { routerPath } from '../../router/routerPath';
import {
  BlueLayout,
  CustomButton,
  CustomTableContainer,
  FormBlock,
  FormInput,
  GridItem,
  PagesContainerUI,
} from '../../styles/styled';
import { NmsMembersType, NmsMemberType, UserResponseType } from './types';

export const NmsMembers = () => {
  const navigate = useNavigate();
  const [nmsMembers, setNmsMembers] = useState<NmsMembersType | null>(null);
  const [fioInputState, setFioInput] = useState<string>('');
  const [searchState, setSearchState] = useState<'search' | 'neutral' | 'clear'>('clear');

  useEffect(() => {
    if (searchState === 'clear') setFioInput('');
    else if (searchState === 'neutral') return;

    (async () => {
      try {
        const usersResponse = await api.get<UserResponseType>(
          searchState === 'clear'
            ? endpoints.getUsersByRole('ROLE_NMS_MEMBER')
            : endpoints.getUsersByRole('ROLE_NMS_MEMBER', fioInputState),
        );

        setSearchState('neutral');

        setNmsMembers(
          usersResponse.data.users.map((el, idx) => {
            return { ...el, key: idx + 1 };
          }),
        );
      } catch (err) {}
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState]);

  const nmsColumns = [
    {
      title: '№ п/п',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'ФИО',
      dataIndex: 'firstname',
      key: 'fio',
      render: (value: string, nmsMember: NmsMemberType) => (
        <Link to={routerPath.nmsMember + nmsMember.id}>
          <p className="text-link">
            {nmsMember?.lastname || '-'} {nmsMember?.firstname} {nmsMember?.patronymic}
          </p>
        </Link>
      ),
    },
    {
      title: 'Контакты',
      dataIndex: 'email',
      key: 'contacts',
    },
  ];

  return (
    <PagesContainerUI>
      <BlueLayout>Члены НМС</BlueLayout>
      <FormBlock>
        <Form onFinish={() => setSearchState('search')}>
          <GridItem gap="20px" direction="column" align="center" justify="center">
            <GridItem width="50%" direction="column" align="flex-start" justify="flex-start">
              <div className="text">ФИО</div>
              <FormInput value={fioInputState} onChange={(e) => setFioInput(e.target.value)} />
            </GridItem>
            <GridItem width="40%" direction="row" align="flex-start" justify="space-around">
              <CustomButton type="submit">Найти</CustomButton>
              <CustomButton type="button" onClick={() => setSearchState('clear')} lined>
                Очистить
              </CustomButton>
            </GridItem>
          </GridItem>
        </Form>
      </FormBlock>
      <GridItem align="flex-end" justify="flex-end">
        <CustomButton width="400px" onClick={() => navigate(routerPath.createNmsMember)}>
          Добавить члена НМС
        </CustomButton>
      </GridItem>
      <CustomTableContainer>
        <Table columns={nmsColumns} dataSource={nmsMembers || []} />
      </CustomTableContainer>
    </PagesContainerUI>
  );
};
